import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Simulateur from "@/pages/Simulateur";
import Tarifs from "@/pages/Tarifs";
import APropos from "@/pages/APropos";
import Actualites from "@/pages/Actualites";
import ArticleDetail from "@/pages/ArticleDetail";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import ConditionsUtilisation from "@/pages/ConditionsUtilisation";
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

function LegacyPostRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/post/${slug}`} replace />;
}

// Map old accented blog post slugs → new ASCII slugs (301 redirect)
const LEGACY_POST_SLUGS = {
  "comparateur-frais-bancaires-pme-eti-2026-toutes-les-banques-sont-elles-compétitives":
    "comparateur-frais-bancaires-pme-eti-2026-toutes-les-banques-sont-elles-competitives",
  "frais-monétiques-des-pme-eti-ce-que-vous-payez-vraiment-et-où-se-cachent-les-marges":
    "frais-monetiques-des-pme-eti-ce-que-vous-payez-vraiment-et-ou-se-cachent-les-marges",
};

function PostRouter() {
  const { slug } = useParams();
  const decoded = decodeURIComponent(slug || "");
  const mapped = LEGACY_POST_SLUGS[decoded];
  if (mapped) return <Navigate to={`/post/${mapped}`} replace />;
  return <ArticleDetail />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            {/* Primary URLs — ASCII slugs (canonical) */}
            <Route path="/simulateur" element={<Simulateur />} />
            <Route path="/simulez-vos-économies-2" element={<Navigate to="/simulateur" replace />} />
            <Route path="/simulateur-v2" element={<Navigate to="/simulateur" replace />} />
            <Route path="/simulateur-2" element={<Navigate to="/simulateur" replace />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/actualites" element={<Actualites />} />
            <Route path="/post/:slug" element={<PostRouter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/conditions-utilisation" element={<ConditionsUtilisation />} />
            <Route path="/conditions-d-utilisation" element={<Navigate to="/conditions-utilisation" replace />} />

            {/* 301 redirects from old accented URLs → ASCII slugs */}
            <Route path="/simulez-vos-économies" element={<Navigate to="/simulateur" replace />} />
            <Route path="/à-propos" element={<Navigate to="/a-propos" replace />} />
            <Route path="/actualités" element={<Navigate to="/actualites" replace />} />
            <Route path="/actualites/:slug" element={<LegacyPostRedirect />} />
            <Route path="/actualités/:slug" element={<LegacyPostRedirect />} />

            {/* 404 catch-all */}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<Suspense fallback={null}><AdminLogin /></Suspense>} />
          <Route path="/admin" element={<Suspense fallback={null}><AdminDashboard /></Suspense>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
